// components/HelpModal/FaqTab.jsx
import React, { useState } from "react";
import "./FaqTab.css";

const FaqTab = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "آیا برنامه رایگان است؟",
      answer: (
        <>
          <p>
            • امکان تماشای فیلم با دو زیرنویس همزمان در اوملنگ کاملا رایگان است
          </p>
          <p>
            • نمایش ترجمه لغات، مترادف، متضاد، مثال‌ها و ... از طریق دیکشنری‌های
            معتبر ثالث (Cambridge, Collins Dictionary, Google, Glosbe, DeepL,
            Bing, Abadis, Fastdic, B-amooz) در نسخه کنونی و تحت وب رایگان
            می‌باشد اما استفاده از دیکشنری داخلی برنامه با توجه به محدودیت‌های
            موجود در سرور برنامه به‌صورت روزانه محدود می‌باشد و بعد از خرید
            اشتراک محدودیت روزانه حذف خواهد شد.
          </p>
          <p>• ذخیره لغات و استفاده از لایتنر نیاز به خرید اشتراک دارد</p>
          <div className="faq-note">
            <strong>توجه:</strong> هدف از انتشار نسخه اولیه برنامه ارائه یک
            ویدئوپلیر قدرتمند و رایگان جهت یادگیری زبان بوده و با توجه به
            هزینه‌های بالای پشتیبانی، برنامه‌نویسی، سرور و دیگر موارد تصمیم بر
            این شد که بخش‌های پرکاربرد به‌صورت رایگان در اختیار کاربر قرار گیرد
            و با دریافت هزینه اندک برای دیگر امکانات، بخشی از هزینه‌های برنامه
            تأمین گردد و این مبالغ تماماً هزینه بهبود و ارتقاء کیفیت برنامه
            می‌گردد.
          </div>
        </>
      ),
    },
    {
      question: "چرا در زیرنویس فارسی فقط یک کادر مشکی مشاهده میشود؟",
      answer: (
        <>
          <p>
            چنانچه برای زیرنویس فارسی شما اشتباها در تنظیمات زبان انگلیسی یا هر
            زبانی به غیر از فارسی را انتخاب کرده باشید، متن زیرنویس به شما نمایش
            داده نخواهد شد، برای حل مشکل کافی است که زبان زیرنویس را به فارسی
            تغییر دهید
          </p>
          {/* <p>
            • نمایش ترجمه لغات، مترادف، متضاد، مثال‌ها و ... از طریق دیکشنری‌های
            معتبر ثالث (Cambridge, Collins Dictionary, Google, Glosbe, DeepL,
            Bing, Abadis, Fastdic, B-amooz) در نسخه کنونی و تحت وب رایگان
            می‌باشد اما استفاده از دیکشنری داخلی برنامه با توجه به محدودیت‌های
            موجود در سرور برنامه به‌صورت روزانه محدود می‌باشد و بعد از خرید
            اشتراک محدودیت روزانه حذف خواهد شد.
          </p>
          <p>• ذخیره لغات و استفاده از لایتنر نیاز به خرید اشتراک دارد</p>
          <div className="faq-note">
            <strong>توجه:</strong> هدف از انتشار نسخه اولیه برنامه ارائه یک
            ویدئوپلیر قدرتمند و رایگان جهت یادگیری زبان بوده و با توجه به
            هزینه‌های بالای پشتیبانی، برنامه‌نویسی، سرور و دیگر موارد تصمیم بر
            این شد که بخش‌های پرکاربرد به‌صورت رایگان در اختیار کاربر قرار گیرد
            و با دریافت هزینه اندک برای دیگر امکانات، بخشی از هزینه‌های برنامه
            تأمین گردد و این مبالغ تماماً هزینه بهبود و ارتقاء کیفیت برنامه
            می‌گردد.
          </div> */}
        </>
      ),
    },
    {
      question:
        "سریال فرندز به همراه لغات و اصطلاحات و دو زیرنویس همزمان را از کجا دانلود کنم؟",
      answer: (
        <>
          <p>
            یکی از پرطرفدارترین سریال‌ها برای یادگیری زبان با فیلم و سریال،
            سریال فرندز می‌باشد و به همین دلیل برخی از زبان‌آموزان اقدام به
            انتشار سریال فرندز در بستر تلگرام نموده‌اند که می‌توان به راحتی آن
            را دانلود نمود و با اوملنگ ، این سریال پرطرفدار را با دو زیرنویس
            همزمان مشاهده کنید. با کلیک بر روی لینک‌های زیر می‌توانید از این
            کانال استفاده کنید و یا از دیگر منابع اقدام به دانلود این سریال
            کنید:
          </p>
          <div className="faq-links">
            <a
              href="https://www.google.com/search?q=%DB%8C%D8%A7%D8%AF%DA%AF%DB%8C%D8%B1%DB%8C%20%D8%B2%D8%A8%D8%A7%D9%86%20%D8%A8%D8%A7%20%D9%81%DB%8C%D9%84%D9%85%20%D9%88%20%D8%B3%D8%B1%DB%8C%D8%A7%D9%84%20+%20%D8%AF%D8%A7%D9%86%D9%84%D9%88%D8%AF%20%D9%81%D8%B1%D9%86%D8%AF%D8%B2%20%D8%A7%D9%88%D9%85%D9%84%D9%86%DA%AF"
              target="_blank"
              rel="noopener noreferrer"
              className="faq-link"
            >
              دریافت سریال فرندز با جستجو
            </a>
            <span>یا</span>
            <a
              href="https://t.me/+0p-N-Ni7GWU1MmVk"
              target="_blank"
              rel="noopener noreferrer"
              className="faq-link"
            >
              دانلود مستقیم سریال فرندز با دو زیرنویس همزمان در کانال تلگرام
            </a>
          </div>
          <p>
            با توجه به قوانین موجود، انتشار فیلم در برنامه نیازمند سانسور در
            فیلم‌ها می‌باشد و اوملنگ به هیچ وجه موافق با سانسور محتوا نمی‌باشد و
            به همین دلیل در این برنامه هیچ فیلمی به‌صورت مستقیم منتشر نمی‌گردد،
            اما برنامه‌ریزی برنامه به شکلی صورت گرفته که شما می‌توانید سریال
            فرندز را از هر منبعی که در دسترس دارید دانلود کنید و با اوملنگ اقدام
            به تماشای سریال با دو زیرنویس نمایید.
          </p>
        </>
      ),
    },
    {
      question:
        "فیلم و سریال با دو زیرنویس همزمان رایگان رو از کجا دانلود کنم؟",
      answer: (
        <>
          <p>
            سایت و کانال‌های تلگرامی وجود دارند که فیلم و سریال با دو زیرنویس
            همزمان منتشر می‌کنند.
          </p>
          <p>به‌عنوان مثال می‌توانید کانال two_sub رو در تلگرام جستجو کنید:</p>
          <div className="faq-links">
            <a
              href="https://t.me/two_sub"
              target="_blank"
              rel="noopener noreferrer"
              className="faq-link"
            >
              دریافت رایگان فیلم و سریال با دو زیرنویس همزمان
            </a>
          </div>
        </>
      ),
    },
    {
      question: "آیا برنامه نسخه موبایل نیز دارد؟",
      answer: (
        <>
          <p>
            بله با کلیک بر روی لینک زیر می‌توانید نسخه موبایل برنامه را دریافت
            کنید:
          </p>
          <div className="faq-links">
            <a
              href="https://app.umlang.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="faq-link"
            >
              دریافت اپلیکیشن موبایل
            </a>
          </div>
        </>
      ),
    },
    {
      question: "برنامه دارای چه امکاناتی است؟",
      answer: (
        <>
          <p>• نمایش دو زیرنویس همزمان</p>
          <p>• دیکشنری درون برنامه</p>
          <p>
            • امکان مشاهده ترجمه، تلفظ، نمونه کاربرد و ... با استفاده از بهترین
            دیکشنری‌های آنلاین
          </p>
          <p>• ذخیره سریع</p>
          <p>• ذخیره پیشرفته لغات و اصطلاحات</p>
          <p>• مرور لغات به روش SRS در لایتنر</p>
          <p>• اجرای آسان تکنیک محبوب و کاربردی سایه (Shadowing)</p>
          <p>
            • کلیدهای میانبر جهت تکرار زیرنویس و مشاهده زیرنویس‌های قبلی و بعدی
          </p>
          <p>
            • عدم وابستگی به سرعت اینترنت (اول فیلم رو با خیال راحت دانلود کن
            بعداً بدون دغدغه تماشاش کن و زبان یاد بگیر)
          </p>
          <p>• امکان هماهنگ‌سازی زیرنویس‌ها</p>
          <p>• تغییر فونت زیرنویس اول و دوم</p>
          <p>• تغییر رنگ زیرنویس اول و دوم</p>
          <p>• تغییر بک‌گراند زیرنویس اول و دوم</p>
          <p>• جابجایی آسان زیرنویس اول و دوم</p>
          <p>• امکان مشاهده بروزترین فیلم‌ها و سریال‌های دنیا</p>
        </>
      ),
    },
    {
      question: "فیلم صدا دارد اما تصویر ندارد؟",
      answer: (
        <>
          <p>
            CPU های نسل جدید از اکثر فرمت‌های ویدئویی پشتیبانی می‌کنند اما
            چنانچه کامپیوتر شما خیلی قدیمی است به‌صورت سخت‌افزاری امکان پخش برخی
            از کدک‌های فشرده‌سازی (از جمله x265) وجود ندارد.
          </p>
        </>
      ),
    },
    {
      question: "چطور به فیلم زیرنویس اضافه کنم؟",
      answer: (
        <>
          <p>
            روش‌های گوناگونی برای اضافه کردن زیرنویس به فیلم وجود دارد از جمله:
          </p>
          <p>1. استفاده مستقیم از بانک زیرنویس برنامه</p>
          <p>2. استفاده مستقیم از فایل زیرنویس</p>
          <p>3. استفاده مستقیم از زیرنویس‌های چسبیده به فیلم</p>
          <p>4. استفاده از دو زیرنویس آنلاین</p>
          <p>5. مقایسه و انتخاب زیرنویس</p>
          {/* <p>
            جهت مشاهده آموزش ویدئویی اضافه کردن زیرنویس بر روی فیلم بر روی لینک
            زیر کلیک کنید:
          </p>
          <div className="faq-links">
            <a
              href="https://app.umlang.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="faq-link"
            >
              مشاهده
            </a>
          </div> */}
        </>
      ),
    },
  ];

  return (
    <div className="faq-tab">
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${openIndex === index ? "faq-open" : ""}`}
          >
            <button
              className="faq-question-btn"
              onClick={() => toggleFaq(index)}
            >
              <div className="faq-question-text">
                <span className="faq-q-mark">Q:</span>
                <span>{faq.question}</span>
              </div>
              <div className="faq-toggle-icon">
                <i
                  className={`fas fa-chevron-down ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                ></i>
              </div>
            </button>
            <div
              className={`faq-answer-wrapper ${
                openIndex === index ? "faq-answer-open" : ""
              }`}
            >
              <div className="faq-answer-content">{faq.answer}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqTab;
